import { render, staticRenderFns } from "./CalendarSidebar.vue?vue&type=template&id=7ffdef0c"
import script from "./CalendarSidebar.vue?vue&type=script&lang=js"
export * from "./CalendarSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports